module.exports = __webpack_public_path__ + "static/media/smares-partner-bg.38317c73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/smares-partner-bg.png
// module id = 158
// module chunks = 0